const getSubCollectionData = require('../services/getSubCollectionData.service')

const getFields = async (workflowRef) => {
  return await getSubCollectionData(workflowRef, 'fields', { orderBy: "fieldsIndex", direction: "asc" })
}

module.exports = getFields